"use client";

import * as React from 'react';
const context = /*#__PURE__*/React.createContext(null);
context.displayName = 'InputGroupContext';
export default context;